export default __webpack_public_path__ + "static/build_on_instructors-217168d3507b329437046b59219717cf.png";